export default "__VITE_ASSET__caee6a3b__"